/* RESPONSIBLE TEAM: team-proactive-support */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default class OutboundWebhookKeyValue extends Fragment {
  @attr('string') declare key: string;
  @attr('string') declare value: string;
}
